// import { useState, useEffect, useCallback, useRef } from "react";
// import { Link } from "react-router-dom";

// const images = ["/slides/heroBanner2.webp", "/slides/heroBanner3.webp"];

// const BannerCarousel = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isHovered, setIsHovered] = useState(false);
//   const [isTransitioning, setIsTransitioning] = useState(false);
//   const [touchStartTime, setTouchStartTime] = useState(0);
//   const autoPlayRef = useRef(null);
//   const touchStartX = useRef(null);
//   const containerRef = useRef(null);

//   // Enhanced auto-play with pause/resume
//   const startAutoPlay = useCallback(() => {
//     if (autoPlayRef.current) clearInterval(autoPlayRef.current);
//     autoPlayRef.current = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % images.length);
//     }, 5000);
//   }, []);

//   const pauseAutoPlay = useCallback(() => {
//     if (autoPlayRef.current) {
//       clearInterval(autoPlayRef.current);
//       autoPlayRef.current = null;
//     }
//   }, []);

//   // Smooth transitions with delay
//   const goToSlide = useCallback(
//     (index) => {
//       if (isTransitioning) return;

//       setIsTransitioning(true);
//       setCurrentIndex(index);

//       // Reset transitioning state after animation
//       setTimeout(() => setIsTransitioning(false), 700);
//     },
//     [isTransitioning],
//   );

//   const nextSlide = useCallback(() => {
//     goToSlide((currentIndex + 1) % images.length);
//   }, [currentIndex, goToSlide]);

//   const prevSlide = useCallback(() => {
//     goToSlide(currentIndex === 0 ? images.length - 1 : currentIndex - 1);
//   }, [currentIndex, goToSlide]);

//   // Keyboard navigation
//   const handleKeyDown = useCallback(
//     (e) => {
//       if (!containerRef.current?.contains(document.activeElement)) return;

//       switch (e.key) {
//         case "ArrowLeft":
//           e.preventDefault();
//           prevSlide();
//           break;
//         case "ArrowRight":
//           e.preventDefault();
//           nextSlide();
//           break;
//         case "Home":
//           e.preventDefault();
//           goToSlide(0);
//           break;
//         case "End":
//           e.preventDefault();
//           goToSlide(images.length - 1);
//           break;
//         default:
//           break;
//       }
//     },
//     [prevSlide, nextSlide, goToSlide],
//   );

//   // Enhanced touch handling
//   const onTouchStart = (e) => {
//     touchStartX.current = e.touches[0].clientX;
//     setTouchStartTime(Date.now());
//     pauseAutoPlay();
//   };

//   const onTouchMove = (e) => {
//     if (!touchStartX.current || isTransitioning) return;

//     const currentX = e.touches[0].clientX;
//     const delta = touchStartX.current - currentX;
//     const container = containerRef.current;

//     if (container) {
//       // Add subtle drag effect
//       const dragPercentage = delta / window.innerWidth;
//       container.style.transform = `translateX(calc(-${currentIndex * 100}% - ${
//         dragPercentage * 100
//       }px))`;
//     }
//   };

//   const onTouchEnd = (e) => {
//     if (!touchStartX.current) return;

//     const endX = e.changedTouches[0].clientX;
//     const delta = touchStartX.current - endX;
//     const timeElapsed = Date.now() - touchStartTime;
//     const velocity = Math.abs(delta) / timeElapsed;

//     // Reset drag effect
//     if (containerRef.current) {
//       containerRef.current.style.transform = "";
//     }

//     // Determine swipe based on distance or velocity
//     const minSwipeDistance = 50;
//     const minSwipeVelocity = 0.3;

//     if (Math.abs(delta) > minSwipeDistance || velocity > minSwipeVelocity) {
//       delta > 0 ? nextSlide() : prevSlide();
//     }

//     touchStartX.current = null;

//     // Resume autoplay if not hovered
//     if (!isHovered) {
//       startAutoPlay();
//     }
//   };

//   // Auto-play management
//   useEffect(() => {
//     if (isHovered) {
//       pauseAutoPlay();
//     } else {
//       startAutoPlay();
//     }

//     return () => pauseAutoPlay();
//   }, [isHovered, startAutoPlay, pauseAutoPlay]);

//   // Keyboard event listener
//   useEffect(() => {
//     document.addEventListener("keydown", handleKeyDown);
//     return () => document.removeEventListener("keydown", handleKeyDown);
//   }, [handleKeyDown]);

//   // Preload next image for better performance
//   useEffect(() => {
//     const nextIndex = (currentIndex + 1) % images.length;
//     const img = new Image();
//     img.src = images[nextIndex];
//   }, [currentIndex]);

//   // ARIA live region for screen readers
//   const [announcement, setAnnouncement] = useState("");
//   useEffect(() => {
//     setAnnouncement(`Slide ${currentIndex + 1} of ${images.length}`);
//   }, [currentIndex]);

//   return (
//     <section
//       className="relative w-full overflow-hidden bg-gray-100"
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       onTouchStart={onTouchStart}
//       onTouchMove={onTouchMove}
//       onTouchEnd={onTouchEnd}
//       aria-roledescription="carousel"
//       aria-label="Featured banners"
//       ref={containerRef}
//     >
//       {/* ARIA live region for announcements */}
//       <div className="sr-only" aria-live="polite" aria-atomic="true">
//         {announcement}
//       </div>

//       {/* Container with enhanced responsive design */}
//       <div
//         className="
//           relative w-full
//           aspect-[16/10] sm:aspect-[16/9] lg:aspect-[21/9]
//           min-h-[240px] sm:min-h-[340px] lg:min-h-[460px]
//           max-h-[80vh]
//         "
//       >
//         {/* Slides container with smooth transition */}
//         <div
//           className="absolute inset-0 flex h-full transition-transform duration-700 ease-[cubic-bezier(0.4,0,0.2,1)]"
//           style={{ transform: `translateX(-${currentIndex * 100}%)` }}
//           aria-live="polite"
//         >
//           {images.map((image, index) => (
//             <div
//               key={index}
//               className="w-full h-full flex-shrink-0 relative"
//               role="group"
//               aria-roledescription="slide"
//               aria-label={`${index + 1} of ${images.length}`}
//               aria-hidden={index !== currentIndex}
//             >
//               {/* Responsive image with srcset for better performance */}
//               <picture>
//                 <source
//                   srcSet={`${image}?w=800 800w, ${image}?w=1200 1200w, ${image}?w=1920 1920w`}
//                   sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 1920px"
//                   type="image/webp"
//                 />
//                 <img
//                   src={image}
//                   alt={`Slide ${
//                     index + 1
//                   }: Transform your challenges into progress with digital solutions`}
//                   className="w-full h-full object-cover"
//                   loading={index === 0 ? "eager" : "lazy"}
//                   fetchPriority={index === 0 ? "high" : "low"}
//                   draggable="false"
//                   decoding="async"
//                   width="1920"
//                   height="1080"
//                 />
//               </picture>

//               {/* Solid color overlay for consistent text visibility */}
//               <div
//                 className="absolute inset-0 z-10"
//                 style={{
//                   backgroundColor: "rgba(0, 0, 0, 0.5)",
//                   background:
//                     "linear-gradient(to bottom, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.6) 100%)",
//                 }}
//                 aria-hidden="true"
//               />

//               {/* Content overlay with better semantic structure */}
//               <div className="absolute inset-0 z-20 grid place-items-center pt-10">
//                 <div
//                   className="
//                     w-full max-w-[1200px]
//                     px-4 sm:px-8 md:px-12 lg:px-16
//                     text-center
//                     [padding-left:max(1rem,env(safe-area-inset-left))]
//                     [padding-right:max(1rem,env(safe-area-inset-right))]
//                   "
//                 >
//                   <h1
//                     className="
//                       font-bold tracking-tight
//                       text-[clamp(1.35rem,4.2vw,4rem)]
//                       leading-[1.15] sm:leading-[1.1] lg:leading-[1.08]
//                       animate-fade-in-up
//                     "
//                     style={{
//                       color: "#ffffff",
//                       textShadow: "0 2px 4px rgba(0,0,0,0.5)",
//                     }}
//                   >
//                     <span style={{ color: "#0d5c7a" }}>Transform</span> your
//                     challenges
//                     <br className="hidden sm:block" />
//                     into progress with the power of
//                     <br className="hidden sm:block" />
//                     <span style={{ color: "#0d5c7a" }}>digital</span>
//                   </h1>

//                   <p
//                     className="
//                       mt-4 sm:mt-6
//                       max-w-[62ch] mx-auto
//                       text-[clamp(0.9rem,1.3vw,1.125rem)]
//                       leading-6 sm:leading-7
//                       animate-fade-in-up
//                       animate-delay-200
//                       hidden md:block
//                     "
//                     style={{
//                       color: "#f8fafc",
//                       textShadow: "0 1px 2px rgba(0,0,0,0.5)",
//                     }}
//                   >
//                     As trusted supply chain specialists, we partner with
//                     organizations to enhance operational efficiency and
//                     long-term profitability by integrating leading-edge digital
//                     solutions.
//                   </p>

//                   <div className="mt-6 sm:mt-8 justify-center animate-fade-in-up animate-delay-400 hidden md:block">
//                     <Link
//                       to="/services"
//                       className="
//     cursor-pointer
//     inline-block rounded-full border-2
//     px-6 sm:px-8 py-2.5 sm:py-3
//     text-[clamp(0.85rem,1vw,1rem)]
//     font-semibold
//     transition-all duration-300
//     hover:bg-white hover:text-black
//     focus:outline-none focus:ring-3 focus:ring-offset-2
//     active:scale-95
//     backdrop-blur-sm
//   "
//                       style={{
//                         color: "#ffffff",
//                         borderColor: "#ffffff",
//                         backgroundColor: "rgba(13, 92, 122, 0.3)",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
//                       }}
//                       aria-label="Explore our services"
//                     >
//                       Explore Our Services
//                       <span className="ml-2" aria-hidden="true">
//                         →
//                       </span>
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Enhanced navigation controls */}
//         <div className="absolute inset-0 z-30">
//           {/* Previous button */}
//           <button
//             onClick={prevSlide}
//             className={`
//               absolute top-1/2 left-4 md:left-6
//               -translate-y-1/2
//               w-10 h-10 md:w-12 md:h-12
//               backdrop-blur-sm
//               flex items-center justify-center
//               transition-all duration-300
//               shadow-lg
//               hover:scale-110 hover:shadow-xl
//               focus:outline-none focus:ring-3 focus:ring-offset-2
//               active:scale-95
//               ${
//                 isHovered || window.innerWidth < 768
//                   ? "opacity-100"
//                   : "opacity-0"
//               }
//               ${isTransitioning ? "pointer-events-none" : ""}
//             `}
//             style={{
//               // backgroundColor: '#ffffff',
//               color: "#ffffff",
//               // border: '1px solid rgba(255,255,255,0.3)'
//             }}
//             aria-label="Previous slide"
//             disabled={isTransitioning}
//           >
//             <svg
//               className="w-5 h-5 md:w-6 md:h-6"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               aria-hidden="true"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M15 19l-7-7 7-7"
//               />
//             </svg>
//           </button>

//           {/* Next button */}
//           <button
//             onClick={nextSlide}
//             className={`
//               absolute top-1/2 right-4 md:right-6
//               -translate-y-1/2
//               w-10 h-10 md:w-12 md:h-12
//               backdrop-blur-sm
//               flex items-center justify-center
//               transition-all duration-300
//               shadow-lg
//               hover:scale-110 hover:shadow-xl
//               focus:outline-none focus:ring-3 focus:ring-offset-2
//               active:scale-95
//               ${
//                 isHovered || window.innerWidth < 768
//                   ? "opacity-100"
//                   : "opacity-0"
//               }
//               ${isTransitioning ? "pointer-events-none" : ""}
//             `}
//             style={{
//               // backgroundColor: '#ffffff',
//               color: "#ffffff",
//               // border: '1px solid rgba(255,255,255,0.3)'
//             }}
//             aria-label="Next slide"
//             disabled={isTransitioning}
//           >
//             <svg
//               className="w-5 h-5 md:w-6 md:h-6"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               aria-hidden="true"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M9 5l7 7-7 7"
//               />
//             </svg>
//           </button>
//         </div>

//         {/* Enhanced pagination dots */}
//         <div
//           className="absolute bottom-4 sm:bottom-6 left-0 right-0 z-30 flex justify-center gap-2 sm:gap-3"
//           role="tablist"
//           aria-label="Slide navigation"
//         >
//           {images.map((_, index) => (
//             <button
//               key={index}
//               role="tab"
//               aria-label={`Go to slide ${index + 1}`}
//               aria-selected={currentIndex === index}
//               onClick={() => goToSlide(index)}
//               className={`
//                 relative
//                 w-3 h-3 sm:w-4 sm:h-4
//                 rounded-full
//                 transition-all duration-300
//                 focus:outline-none focus:ring-2 focus:ring-offset-2
//                 hover:scale-125
//                 ${isTransitioning ? "pointer-events-none" : ""}
//               `}
//               style={{
//                 backgroundColor:
//                   currentIndex === index
//                     ? "#0d5c7a"
//                     : "rgba(255, 255, 255, 0.7)",
//                 boxShadow:
//                   currentIndex === index
//                     ? "0 2px 8px rgba(13, 92, 122, 0.5)"
//                     : "none",
//               }}
//               disabled={isTransitioning}
//             >
//               {/* Active indicator animation */}
//               {currentIndex === index && (
//                 <span
//                   className="absolute inset-0 rounded-full animate-ping opacity-75"
//                   style={{ backgroundColor: "#0d5c7a" }}
//                   aria-hidden="true"
//                 />
//               )}
//             </button>
//           ))}
//         </div>

//         {/* Slide counter for screen readers */}
//         <div className="sr-only" aria-live="polite" aria-atomic="true">
//           Slide {currentIndex + 1} of {images.length}
//         </div>
//       </div>

//       {/* Progress indicator for auto-play */}
//       <div
//         className="absolute bottom-0 left-0 right-0 h-1 z-30"
//         style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
//         aria-hidden="true"
//       >
//         <div
//           className="h-full transition-all duration-1000 ease-linear"
//           style={{
//             width: isHovered ? "0%" : "100%",
//             backgroundColor: "#0286ba",
//             animation: isHovered ? "none" : "progress 5s linear",
//           }}
//         />
//       </div>

//       {/* Add these styles to your global CSS or Tailwind config */}
//       <style jsx>{`
//         @keyframes progress {
//           from {
//             width: 0%;
//           }
//           to {
//             width: 100%;
//           }
//         }

//         .animate-fade-in-up {
//           animation: fadeInUp 0.8s ease-out;
//         }

//         .animate-delay-200 {
//           animation-delay: 200ms;
//         }

//         .animate-delay-400 {
//           animation-delay: 400ms;
//         }

//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//       `}</style>
//     </section>
//   );
// };

// export default BannerCarousel;

import { useState, useEffect, useCallback, useRef } from "react";
import { Link } from "react-router-dom";

const images = ["/slides/heroBanner2.webp", "/slides/heroBanner3.webp"];

const BannerCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [touchStartTime, setTouchStartTime] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const autoPlayRef = useRef(null);
  const touchStartX = useRef(null);
  const slideContainerRef = useRef(null);

  /* ------------------ Responsive Check ------------------ */
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  /* ------------------ Autoplay ------------------ */
  const startAutoPlay = useCallback(() => {
    if (autoPlayRef.current) clearInterval(autoPlayRef.current);
    autoPlayRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);
  }, []);

  const pauseAutoPlay = useCallback(() => {
    if (autoPlayRef.current) {
      clearInterval(autoPlayRef.current);
      autoPlayRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (isHovered) pauseAutoPlay();
    else startAutoPlay();

    return () => pauseAutoPlay();
  }, [isHovered, startAutoPlay, pauseAutoPlay]);

  /* ------------------ Slide Navigation ------------------ */
  const goToSlide = useCallback(
    (index) => {
      if (isTransitioning) return;
      setIsTransitioning(true);
      setCurrentIndex(index);
      setTimeout(() => setIsTransitioning(false), 700);
    },
    [isTransitioning],
  );

  const nextSlide = () => goToSlide((currentIndex + 1) % images.length);

  const prevSlide = () =>
    goToSlide(currentIndex === 0 ? images.length - 1 : currentIndex - 1);

  /* ------------------ Touch Handling ------------------ */
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    setTouchStartTime(Date.now());
    pauseAutoPlay();
  };

  const onTouchMove = (e) => {
    if (!touchStartX.current || isTransitioning) return;
    const currentX = e.touches[0].clientX;
    const delta = touchStartX.current - currentX;

    if (slideContainerRef.current) {
      slideContainerRef.current.style.transform = `translateX(calc(-${
        currentIndex * 100
      }% - ${delta}px))`;
    }
  };

  const onTouchEnd = (e) => {
    if (!touchStartX.current) return;

    const endX = e.changedTouches[0].clientX;
    const delta = touchStartX.current - endX;
    const timeElapsed = Date.now() - touchStartTime;
    const velocity = Math.abs(delta) / timeElapsed;

    slideContainerRef.current.style.transform = "";

    const minSwipeDistance = 50;
    const minSwipeVelocity = 0.3;

    if (Math.abs(delta) > minSwipeDistance || velocity > minSwipeVelocity) {
      delta > 0 ? nextSlide() : prevSlide();
    }

    touchStartX.current = null;
    if (!isHovered) startAutoPlay();
  };

  /* ------------------ Keyboard ------------------ */
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") prevSlide();
      if (e.key === "ArrowRight") nextSlide();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  });

  return (
    <section
      className="relative w-full overflow-hidden bg-gray-100"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {/* Slide Wrapper */}
      <div className="relative w-full aspect-[16/9] min-h-[300px] max-h-[80vh]">
        <div
          ref={slideContainerRef}
          className="absolute inset-0 flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {images.map((image, index) => (
            <div key={index} className="w-full flex-shrink-0 relative">
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
                draggable="false"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-black/50" />

              {/* Content */}
              <div className="absolute inset-0 z-20 grid place-items-center text-center px-6">
                <div className="max-w-4xl">
                  <h1 className="text-white font-bold text-[clamp(1.5rem,4vw,4rem)] leading-tight">
                    <span className="text-[#0d5c7a]">Transform</span> your
                    challenges into progress with the power of{" "}
                    <span className="text-[#0d5c7a]">digital</span>
                  </h1>

                  <p className="mt-6 text-gray-200 hidden md:block">
                    As trusted supply chain specialists, we enhance operational
                    efficiency using leading-edge digital solutions.
                  </p>

                  {/* ✅ FIXED BUTTON */}
                  <div className="mt-8 hidden md:block">
                    <Link
                      to="/services"
                      className="inline-block rounded-full border-2 px-8 py-3 font-semibold transition-all duration-300 hover:bg-white hover:text-black active:scale-95 backdrop-blur-sm"
                      style={{
                        color: "#ffffff",
                        borderColor: "#ffffff",
                        backgroundColor: "rgba(13, 92, 122, 0.3)",
                      }}
                    >
                      Explore Our Services →
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Controls */}
        <div className="absolute inset-0 z-30 pointer-events-none">
          <button
            onClick={prevSlide}
            className={`absolute top-1/2 left-4 -translate-y-1/2 w-10 h-10 flex items-center justify-center text-white pointer-events-auto ${
              isHovered || isMobile ? "opacity-100" : "opacity-0"
            }`}
          >
            ‹
          </button>

          <button
            onClick={nextSlide}
            className={`absolute top-1/2 right-4 -translate-y-1/2 w-10 h-10 flex items-center justify-center text-white pointer-events-auto ${
              isHovered || isMobile ? "opacity-100" : "opacity-0"
            }`}
          >
            ›
          </button>
        </div>
      </div>
    </section>
  );
};

export default BannerCarousel;
